import { ButtonIcon } from '@statsbomb/kitbag-components';
import { forwardRef, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { twJoin } from 'tailwind-merge';

export const SelectedListItem = forwardRef(
  (
    {
      children,
      onClick,
      onRemove,
      ariaLabel,
      style,
      testId,
      isActive,
    }: {
      onClick?: () => void;
      children: ReactNode;
      onRemove?: () => void;
      ariaLabel?: string;
      style?: React.CSSProperties;
      testId?: string;
      isActive?: boolean;
    },
    ref: React.Ref<HTMLLIElement>,
  ) => {
    const { t } = useTranslation('accessibility');

    // Ensure the component is either clickable or removable, so we don't render a button within a button.
    const isButton = !!onClick && !onRemove;
    const Content = isButton ? 'button' : 'div';

    return (
      <li className="w-full rounded-sb" aria-label={ariaLabel} style={style} ref={ref} data-testid={testId}>
        <Content
          type={isButton ? 'button' : undefined}
          onClick={isButton ? onClick : undefined}
          className={twJoin(
            'w-full h-8 py-1 rounded-sb flex items-center justify-between',
            isActive
              ? 'bg-interface-main/sb-highlight border-interface-main border-l-4 pr-2 pl-1'
              : 'px-2 bg-canvas-tertiary-main',
          )}
        >
          {children}
          {onRemove && (
            <ButtonIcon icon="Close" onClick={onRemove} size="small" variant="ghost">
              {t('listItem.remove', { item: ariaLabel || t('listItem.item'), interpolation: { escapeValue: false } })}
            </ButtonIcon>
          )}
        </Content>
      </li>
    );
  },
);
